// Add these new API endpoints to your environment.ts file

import { Domain } from "domain";
import { apikeys } from "./apikeys";
import { webddn } from "./webddn";
import { buildInfo } from "./build-info";
import { EnvironmentFeatures } from "./environment.types";
const API_DOMAIN = webddn.API_DOMAIN;

export const environment = {
    production: true,
    debugMode: false,
    buildDate: buildInfo.buildDate,
    buildId: buildInfo.buildId,
    gitSha: buildInfo.gitSha,
    version: buildInfo.version,
  // Google Photos API Configuration
  GOOGLE_API_KEY: 'your-google-api-key-here',
  GOOGLE_PHOTOS_CLIENT_ID: 'your-google-photos-client-id-here',
  COMPANY: webddn.DOMAIN,
  features: {
    publish: true,
    // kanban: true,
    // payment: true,
    // contentEditor: true
    dashboard: true,
    team: true,
    // Shipping Module Features
    shipping: true,              // Master toggle for entire shipping module
    storePickup: true,          // Enable/disable store pickup option
    amazonShipping: true,       // Amazon Buy Shipping API
    canadaPost: true,           // Canada Post integration
    ups: true,                  // UPS integration
    fedex: true                 // FedEx integration
  } satisfies EnvironmentFeatures,
  STRIPE_PK: (() => {
    if ('stripe_pk_live' in apikeys) {
      return (apikeys as any).stripe_pk_live;
    } else if ('stripe_pk_test' in apikeys) {
      return (apikeys as any).stripe_pk_test;
    }
    return null; // Fallback if neither key exists
  })(),
  BASEURL: 'https://',
  API_DOMAIN: API_DOMAIN,
  // Feature flags
  enableTemplateEditing: false,
  allowManualEmailsInProd: false,
  NOTIFICATIONS_STREAM_APIURL: API_DOMAIN + webddn.DOMAIN + '/notifications/stream',
  NOTIFICATIONS_SEND_APIURL: API_DOMAIN + webddn.DOMAIN + '/notifications/send',
  NOTIFICATIONS_STATUS_APIURL: API_DOMAIN + webddn.DOMAIN + '/notifications/status',
  NOTIFICATIONS_INBOX_APIURL: API_DOMAIN + webddn.DOMAIN + '/notifications',
  NOTIFICATIONS_UNREAD_APIURL: API_DOMAIN + webddn.DOMAIN + '/notifications/unread-count',
  NOTIFICATIONS_READ_ALL_APIURL: API_DOMAIN + webddn.DOMAIN + '/notifications/read-all',
  NOTIFICATIONS_ADMIN_APIURL: API_DOMAIN + webddn.DOMAIN + '/notifications/admin',
  NOTIFICATIONS_DEVICES_APIURL: API_DOMAIN + webddn.DOMAIN + '/notifications/devices',
  NOTIFICATIONS_PREFS_APIURL: API_DOMAIN + webddn.DOMAIN + '/user/notification-preferences',
  KANBAN_PREFS_APIURL: API_DOMAIN + webddn.DOMAIN + '/user/kanban-preferences',
  BLACKBOARD_APIURL: API_DOMAIN + webddn.DOMAIN + '/blackboard',
  // Distributed logging sink (receives Angular DistributedLogService batches)
  TELEMETRY_LOGS_APIURL: API_DOMAIN + webddn.DOMAIN + '/telemetry/logs',
  distributedLog: {
    enabled: true,
    endpoint: API_DOMAIN + webddn.DOMAIN + '/telemetry/logs',
    bufferLimit: 500,
    flushIntervalMs: 30000,
    consoleLevels: ['warn', 'error', 'fatal'] as Array<'debug' | 'info' | 'warn' | 'error' | 'fatal'>,
    selfPath: '/telemetry/logs',
  },
  CONTENTURL: API_DOMAIN + webddn.DOMAIN + '/getcontent',
  CONTENT_APIURL: API_DOMAIN + webddn.DOMAIN + '/content',
  CONTENT_NAMES_APIURL: API_DOMAIN + webddn.DOMAIN + '/content-names',
  INFO_APIURL: API_DOMAIN + webddn.DOMAIN + '/info',
  INFO_TITLE_APIURL: API_DOMAIN + webddn.DOMAIN + '/info-title',
  INFO_ROUTE_APIURL: API_DOMAIN + webddn.DOMAIN + '/info-route',
  SCRAPER_APIURL: API_DOMAIN + webddn.DOMAIN + '/scraper',

  // Pain Assessment APIs
  ACTION_PLANS_APIURL: API_DOMAIN + webddn.DOMAIN + '/action-plans',
  ASSESSMENT_APIURL: API_DOMAIN  + webddn.DOMAIN + '/assessment',
  FOLLOW_UP_APIURL: API_DOMAIN  + webddn.DOMAIN + '/follow-up',

  // HCAI MVA Billing APIs
  HCAI_PLANS_APIURL: API_DOMAIN + webddn.DOMAIN + '/hcai/plans',
  HCAI_SESSIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/hcai/sessions',
  HCAI_LEDGER_APIURL: API_DOMAIN + webddn.DOMAIN + '/hcai/ledger',
  HCAI_INSURERS_APIURL: API_DOMAIN + webddn.DOMAIN + '/hcai/insurers',
  HCAI_INVOICES_APIURL: API_DOMAIN + webddn.DOMAIN + '/hcai/invoices',
  HCAI_CONFIG_APIURL: API_DOMAIN + webddn.DOMAIN + '/hcai/config',
  HCAI_HEALTH_APIURL: API_DOMAIN + webddn.DOMAIN + '/hcai/health',
  HCAI_CODES_SEED_APIURL: API_DOMAIN + webddn.DOMAIN + '/hcai/codes/seed',
  HCAI_ATTENDANT_ASSESSMENTS_APIURL: API_DOMAIN + webddn.DOMAIN + '/hcai/attendant-assessments',

  // Patient Intake APIs
  PATIENT_INTAKE_APIURL: API_DOMAIN + webddn.DOMAIN + '/patient-intake',

  // Appointment Booking APIs
  APPOINTMENTS_AVAILABLE_SLOTS_APIURL: API_DOMAIN + webddn.DOMAIN + '/appointments/available-slots',
  APPOINTMENTS_CLINIC_HOURS_APIURL: API_DOMAIN + webddn.DOMAIN + '/appointments/clinic-hours',
  APPOINTMENTS_BOOK_APIURL: API_DOMAIN + webddn.DOMAIN + '/appointments/book',
  APPOINTMENTS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/appointments',
  APPOINTMENTS_CANCEL_APIURL: API_DOMAIN + webddn.DOMAIN + '/appointments',
  APPOINTMENTS_MY_APIURL: API_DOMAIN + webddn.DOMAIN + '/appointments/my-appointments',
  APPOINTMENTS_ADMIN_APIURL: API_DOMAIN + webddn.DOMAIN + '/appointments/admin/all',

  // Activity Management APIs
  ACTIVITIES_APIURL: API_DOMAIN + webddn.DOMAIN + '/activities',
  ACTIVITIES_BOOKABLE_APIURL: API_DOMAIN + webddn.DOMAIN + '/activities/bookable',
  ACTIVITIES_SEED_APIURL: API_DOMAIN + webddn.DOMAIN + '/activities/seed',
  TREATMENT_TEMPLATES_APIURL: API_DOMAIN + webddn.DOMAIN + '/treatment-templates',

  // Case Management APIs
  CASES_APIURL: API_DOMAIN + webddn.DOMAIN + '/cases',

  // Schedule Management APIs
  SCHEDULE_USERS_APIURL: API_DOMAIN + webddn.DOMAIN + '/schedule/users',
  SCHEDULE_WEEKLY_APIURL: API_DOMAIN + webddn.DOMAIN + '/schedule/weekly',
  SCHEDULE_BLOCKOFF_APIURL: API_DOMAIN + webddn.DOMAIN + '/schedule/blockoff',
  MY_SCHEDULE_WEEKLY_APIURL: API_DOMAIN + webddn.DOMAIN + '/schedule/my-weekly',

  APIKEY: API_DOMAIN + webddn.DOMAIN + '/apikeys',
  DRAFTAPIURL: API_DOMAIN + webddn.DOMAIN + '/draftid',
  DRAFTORDERIDAPIURL: API_DOMAIN + webddn.DOMAIN + '/draftorderid',
  DRAFT_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/updatedraft',
  DRAFT_SEND_APIURL: API_DOMAIN + webddn.DOMAIN + '/senddraftcontact',
  DRAFT_SIGN_INFO_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/updatedraftsign',
  DRAFT_SIGN_INFO_SEND_APIURL: API_DOMAIN + webddn.DOMAIN + '/senddraftsign',
  DRAFT_SIGN_INFO2_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/updatedraftsign2',
  DRAFT_SIGN_INFO2_SEND_APIURL: API_DOMAIN + webddn.DOMAIN + '/senddraftsign2',
  PASSENGER_ADD_APIURL: API_DOMAIN + webddn.DOMAIN + '/addpassenger',
  PASSENGERS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getpassengers',
  MANAGERS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getmanagers',

  // Manager Approval APIs
  PENDING_MANAGERS_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/pending-managers',
  APPROVE_MANAGER_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/approve-manager',
  REJECT_MANAGER_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/reject-manager',
  BULK_APPROVE_MANAGERS_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/bulk-approve-managers',
  SET_PENDING_MANAGER_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/set-pending-manager',

  // Business User Approval APIs
  PENDING_BUSINESS_USERS_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/pending-business-users',
  APPROVE_BUSINESS_USER_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/approve-business-user',
  REJECT_BUSINESS_USER_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/reject-business-user',
  BULK_APPROVE_BUSINESS_USERS_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/bulk-approve-business-users',
  SET_PENDING_BUSINESS_USER_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/set-pending-business-user',

  // Transporter Approval APIs
  PENDING_TRANSPORTERS_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/pending-transporters',
  APPROVE_TRANSPORTER_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/approve-transporter',
  REJECT_TRANSPORTER_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/reject-transporter',
  BULK_APPROVE_TRANSPORTERS_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/bulk-approve-transporters',
  SET_PENDING_TRANSPORTER_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/set-pending-transporter',

  // Generic (role/user_type-agnostic) Approval APIs
  PENDING_USERS_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/pending-users',
  APPROVE_USER_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/approve-user',
  REJECT_USER_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/reject-user',
  SET_PENDING_USER_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/set-pending-user',

  PASSENGER_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/updatepassenger',
  PASSENGER_DELETE_APIURL: API_DOMAIN + webddn.DOMAIN + '/deletepassenger',
   PASSENGER_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getpassenger',

    
  BUILD_ALL_APIURL: API_DOMAIN + webddn.DOMAIN + '/buildall',

  TEAM_ADD_APIURL: API_DOMAIN + webddn.DOMAIN + '/addteam',
  TEAM_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/updateteam',
  TEAM_ASSIGNEES_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/updateteamassignees',
  TEAM_DELETE_APIURL: API_DOMAIN + webddn.DOMAIN + '/deleteteam',
  TEAM_CANCEL_APIURL: API_DOMAIN + webddn.DOMAIN + '/cancelteam',
  TEAMS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getteams',
  NEW_TEAMS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getnewteams',
  PAST_TEAMS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getpastteams',
  TEAM_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getteam',
  TEAM_DETAILS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/get-team-details',

  // Task Management API URLs
  TASK_ADD_APIURL: API_DOMAIN + webddn.DOMAIN + '/addtask',
  TASK_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/updatetask',
  TASK_DELETE_APIURL: API_DOMAIN + webddn.DOMAIN + '/deletetask',
  TASK_ARCHIVE_APIURL: API_DOMAIN + webddn.DOMAIN + '/archivetask',
  TASK_UNARCHIVE_APIURL: API_DOMAIN + webddn.DOMAIN + '/unarchivetask',
  TASK_DELETE_ARCHIVE_APIURL: API_DOMAIN + webddn.DOMAIN + '/deletearchive',
  TASK_UPDATE_ARCHIVE_APIURL: API_DOMAIN + webddn.DOMAIN + '/updatearchive',
  TASK_ADD_ARCHIVE_APIURL: API_DOMAIN + webddn.DOMAIN + '/addarchive',
  TASK_TRASH_APIURL: API_DOMAIN + webddn.DOMAIN + '/trashtask',
  TASK_DELETE_TRASH_APIURL: API_DOMAIN + webddn.DOMAIN + '/deletetrash',
  TASK_UPDATE_TRASH_APIURL: API_DOMAIN + webddn.DOMAIN + '/updatetrash',
  TASK_DUPLICATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/duplicatetask',
  TASK_MOVE_APIURL: API_DOMAIN + webddn.DOMAIN + '/movetask',
  TASK_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/gettask',
  TASKS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/gettasks',
  ARCHIVES_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getarchives',
  TRASHES_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/gettrashes',
  KANBAN_LABELS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/kanban-labels',
  KANBAN_LABELS_POST_APIURL: API_DOMAIN + webddn.DOMAIN + '/kanban-labels',
  KANBAN_LABELS_BATCH_APIURL: API_DOMAIN + webddn.DOMAIN + '/kanban-labels-batch',
  ALL_DOMAINS_TASKS_APIURL: API_DOMAIN + webddn.DOMAIN + '/getalldomainstasks',
  ALL_DOMAINS_ARCHIVES_APIURL: API_DOMAIN + webddn.DOMAIN + '/getalldomainsarchives',
  ALL_DOMAINS_TRASHES_APIURL: API_DOMAIN + webddn.DOMAIN + '/getalldomainstrashes',
  TASK_ATTACHMENT_BASE_APIURL: API_DOMAIN,
  TASK_COMMENTS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/tasks',
  TASK_COMMENTS_POST_APIURL: API_DOMAIN + webddn.DOMAIN + '/tasks',
  TASK_COMMENTS_PATCH_APIURL: API_DOMAIN + webddn.DOMAIN + '/tasks',
  TASK_COMMENTS_DELETE_APIURL: API_DOMAIN + webddn.DOMAIN + '/tasks',
  TASK_COMMENTS_REACTION_APIURL: API_DOMAIN + webddn.DOMAIN + '/tasks',
  TASK_COMMENTS_ATTACHMENT_UPLOAD_APIURL: API_DOMAIN + webddn.DOMAIN + '/tasks',
  KANBAN_INLINE_IMAGE_REQUEST_UPLOAD_APIURL: API_DOMAIN + webddn.DOMAIN + '/kanban/inline-image/request-upload',
  KANBAN_INLINE_IMAGE_MULTIPART_UPLOAD_APIURL: API_DOMAIN + webddn.DOMAIN + '/kanban/inline-image/upload',
  KANBAN_INLINE_IMAGE_READ_URL_APIURL: API_DOMAIN + webddn.DOMAIN + '/kanban/inline-image/read-url',
  KANBAN_INLINE_IMAGE_READ_URLS_APIURL: API_DOMAIN + webddn.DOMAIN + '/kanban/inline-image/read-urls',
  TASK_ATTACHMENTS_READ_URLS_APIURL: API_DOMAIN + webddn.DOMAIN + '/task/attachments/read-urls',
  CONTENT_INLINE_IMAGE_MULTIPART_UPLOAD_APIURL: API_DOMAIN + webddn.DOMAIN + '/content/inline-image/upload',
  CONTENT_INLINE_IMAGE_READ_URL_APIURL: API_DOMAIN + webddn.DOMAIN + '/content/inline-image/read-url',
  IMAGE_BASE_APIURL: API_DOMAIN + '/image/',
  // Free Team Registration API URLs
  REGISTER_FREE_TEAM_APIURL: API_DOMAIN + webddn.DOMAIN + '/register-free-team',
  CHECK_TEAM_FREE_STATUS_APIURL: API_DOMAIN + webddn.DOMAIN + '/teams', // Note: team ID will be appended
  USER_FREE_REGISTRATIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/user/free-registrations',
  TEAMS_APIURL: API_DOMAIN + webddn.DOMAIN + '/teams',
  TEAM_APIURL: API_DOMAIN + webddn.DOMAIN + '/team',

  // Single registration check
  CHECK_REGISTRATION_APIURL: API_DOMAIN + webddn.DOMAIN + '/check-registration',

  // User registration history
  USER_REGISTRATIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/user',

  // Multiple team registration check
  CHECK_MULTIPLE_REGISTRATIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/check-multiple-registrations',
  DEBUG_REGISTRATIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/debug-registrations',

  // Registration Management API URLs
  ADD_REGISTRATION_APIURL: API_DOMAIN + webddn.DOMAIN + '/add-registration',
  REMOVE_REGISTRATION_APIURL: API_DOMAIN + webddn.DOMAIN + '/remove-registration',
  TEAM_REGISTRATIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/team-registrations',
  TEAM_CANCELLED_REGISTRATIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/team-cancelled-registrations',
  MOVE_TO_REGISTRATION_APIURL: API_DOMAIN + webddn.DOMAIN + '/move-to-registration',
  UPDATE_TEAM_REGISTRATION_APIURL: API_DOMAIN + webddn.DOMAIN + '/update-registration',


  TRANSPORTER_ADD_APIURL: API_DOMAIN + webddn.DOMAIN + '/addtransporter',
  TRANSPORTER_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/updatetransporter',
  TRANSPORTER_DELETE_APIURL: API_DOMAIN + webddn.DOMAIN + '/deletetransporter',
  TRANSPORTERS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/gettransporters',
  TRANSPORTER_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/gettransporter',
  COMPANY_ADD_APIURL: API_DOMAIN + webddn.DOMAIN + '/addcompany',
  COMPANY_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/updatecompany',
  COMPANY_DELETE_APIURL: API_DOMAIN + webddn.DOMAIN + '/deletecompany',
  COMPANY_CANCEL_APIURL: API_DOMAIN + webddn.DOMAIN + '/cancelcompany',
  COMPANY_UNCANCEL_APIURL: API_DOMAIN + webddn.DOMAIN + '/uncancelcompany',
  COMPANY_SET_PRIORITY_APIURL: API_DOMAIN + webddn.DOMAIN + '/set-company-priority',
  COMPANY_GET_BY_PRIORITY_APIURL: API_DOMAIN + webddn.DOMAIN + '/companies-by-priority',
  COMPANY_GET_AVAILABLE_PRIORITIES_APIURL: API_DOMAIN + webddn.DOMAIN + '/available-priorities',
  COMPANY_INIT_PRIORITIES_APIURL: API_DOMAIN + webddn.DOMAIN + '/initialize-priorities',
  // Company and User Management APIs
  COMPANY_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getcompany',
  FIRST_COMPANY_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getfirstcompany',
  BUSINESS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getbusiness',

  // Sign Project API URLs
  SIGN_PROJECTS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/sign-projects',
  SIGN_PROJECT_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/sign-projects', // + /:id
  SIGN_PROJECT_ADD_APIURL: API_DOMAIN + webddn.DOMAIN + '/sign-projects',
  SIGN_PROJECT_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/sign-projects', // + /:id
  SIGN_PROJECT_DELETE_APIURL: API_DOMAIN + webddn.DOMAIN + '/sign-projects', // + /:id
  SIGN_PROJECT_ARCHIVE_APIURL: API_DOMAIN + webddn.DOMAIN + '/sign-projects', // + /:id/archive
  SIGN_PROJECT_UNARCHIVE_APIURL: API_DOMAIN + webddn.DOMAIN + '/sign-projects', // + /:id/unarchive
  SIGN_PROJECT_IMAGE_UPLOAD_APIURL: API_DOMAIN + webddn.DOMAIN + '/sign-projects', // + /:id/images
  SIGN_PROJECT_PROOF_GENERATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/sign-projects', // + /:id/proofs
  SIGN_PROJECT_PROOF_EMAIL_APIURL: API_DOMAIN + webddn.DOMAIN + '/sign-projects', // + /:id/proofs/email
  SIGN_PROJECT_PROOF_APPROVE_APIURL: API_DOMAIN + webddn.DOMAIN + '/sign-projects/proofs', // + /:token/approve
  SIGN_PROJECT_WATERMARK_REMOVE_APIURL: API_DOMAIN + webddn.DOMAIN + '/sign-projects', // + /:id/remove-watermarks
  SIGN_PROJECT_PROOF_VIEW_APIURL: API_DOMAIN + webddn.DOMAIN + '/sign-projects/proofs/view', // + /:token
  SIGN_PROJECT_IMAGE_BASE_URL: API_DOMAIN + webddn.DOMAIN + '/sign-projects/image' ,
  // Email Template API (CRUD)
  SIGN_PROJECT_EMAIL_TEMPLATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/sign-projects/email-template',

 
  JOURNEY_ADD_APIURL: API_DOMAIN + webddn.DOMAIN + '/addjourney',
  JOURNEY_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/updatejourney',
  JOURNEY_CANCEL_APIURL: API_DOMAIN + webddn.DOMAIN + '/canceljourney',
  JOURNEY_DELETE_APIURL: API_DOMAIN + webddn.DOMAIN + '/deletejourney',

  







  //All 5 Services

  JOURNEY_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getjourney',
  JOURNEY_MONTH_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getjourneymonth',

  LOGIN_APIURL: API_DOMAIN + webddn.DOMAIN + '/login?api_key=a194981-b541-416e-9351-dd0c3d572647',
  AUTH_GOOGLE_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/google',
  AUTH_APPLE_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/apple',
  AUTH_MICROSOFT_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/microsoft',
  AUTH_PASSKEY_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/passkey',
  PASSWORD_SIGNUP_INCOMPLETE_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/password-signup-incomplete',
  VOICE_PHONE_AVAILABLE_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/voice-phone-available',
  USER_ADD_APIURL: API_DOMAIN + webddn.DOMAIN + '/signup?api_key=a194981-b541-416e-9351-dd0c3d572647',
  PASSWORD_RESET_REQUEST_APIURL: API_DOMAIN + webddn.DOMAIN + '/password-reset/request?api_key=a194981-b541-416e-9351-dd0c3d572647',
  PASSWORD_RESET_VALIDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/password-reset/validate',
  PASSWORD_RESET_RESET_APIURL: API_DOMAIN + webddn.DOMAIN + '/password-reset/reset?api_key=a194981-b541-416e-9351-dd0c3d572647',
  SIGNOUT_APIURL: API_DOMAIN + webddn.DOMAIN + '/signout',


  USER_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getuser',
  USERS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getusers',
  KANBAN_ASSIGNABLE_USERS_APIURL: API_DOMAIN + webddn.DOMAIN + '/kanban/assignable-users',
  KANBAN_ASSIGNABLE_USERS_BATCH_APIURL: API_DOMAIN + webddn.DOMAIN + '/kanban/assignable-users-batch',
  USER_PROFILE_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/profile',
  USER_PROFILE_ENABLE_VOICE_APIURL: API_DOMAIN + webddn.DOMAIN + '/profile/enable-voice',
  USER_PROFILE_PASSKEYS_APIURL: API_DOMAIN + webddn.DOMAIN + '/profile/passkeys',
  USER_PROFILE_DISABLE_VOICE_APIURL: API_DOMAIN + webddn.DOMAIN + '/profile/voice',
  USER_CHANGE_PASSWORD_PUT_APIURL: API_DOMAIN + webddn.DOMAIN + '/change-password',

  BUSINESSUSER_APIURL: API_DOMAIN + webddn.DOMAIN + '/businessuser',

  USER_TIMEZONE_APIURL: API_DOMAIN + webddn.DOMAIN + '/user/timezone',

  // Impersonation Management API URLs
  IMPERSONATE_START_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/impersonate/start',
  IMPERSONATE_END_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/impersonate/end',
  IMPERSONATE_STATUS_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/impersonate/status',
  IMPERSONATE_LOGS_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/impersonate/logs',
  IMPERSONATE_LOG_DETAILS_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/impersonate/logs', // + /:logId
  ADMIN_USERS_LIST_APIURL: API_DOMAIN + webddn.DOMAIN + '/admin/users/list',

  // Enhanced Payment and Installment API URLs
  CREATE_PAYMENT_INTENT_POST_APIURL: API_DOMAIN + webddn.DOMAIN + '/create-payment-intent',
  VERIFY_PAYMENT_POST_APIURL: API_DOMAIN + webddn.DOMAIN + '/verify-payment',
  PROCESS_PAYMENT_APIURL: API_DOMAIN + webddn.DOMAIN + '/process-payment',
  CREATE_SETUP_INTENTT_APIURL: API_DOMAIN + webddn.DOMAIN + '/create-setup-intent',

  // Installment Plan Management APIs
  CREATE_INSTALLMENT_PLAN_APIURL: API_DOMAIN + webddn.DOMAIN + '/create-installment-plan',
  PREVIEW_INSTALLMENT_SCHEDULE_APIURL: API_DOMAIN + webddn.DOMAIN + '/preview-installment-schedule',
  VALIDATE_INSTALLMENT_CONFIG_APIURL: API_DOMAIN + webddn.DOMAIN + '/validate-installment-config',
  GET_INSTALLMENT_OPTIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/installment-options',

  // FIXED: User installment plans endpoint (was pointing to wrong URL)
  USER_INSTALLMENT_PLANS_APIURL: API_DOMAIN + webddn.DOMAIN + '/user-installment-plans',
  GET_INSTALLMENT_SCHEDULE_APIURL: API_DOMAIN + webddn.DOMAIN + '/installment-schedule',
  CANCEL_INSTALLMENT_SCHEDULE_APIURL: API_DOMAIN + webddn.DOMAIN + '/cancel-installment-schedule',
  GET_INSTALLMENT_PLAN_DETAILS_APIURL: API_DOMAIN + webddn.DOMAIN + '/get-installment-plan-details',

  // Subscription Schedule APIs
  CREATE_SUBSCRIPTION_SCHEDULE_APIURL: API_DOMAIN + webddn.DOMAIN + '/create-subscription-schedule',
  UPDATE_SUBSCRIPTION_SCHEDULE_APIURL: API_DOMAIN + webddn.DOMAIN + '/update-subscription-schedule',
  CANCEL_SUBSCRIPTION_SCHEDULE_APIURL: API_DOMAIN + webddn.DOMAIN + '/cancel-subscription-schedule',
  GET_SUBSCRIPTION_SCHEDULE_APIURL: API_DOMAIN + webddn.DOMAIN + '/subscription-schedule',

  // Order and Member Status Management APIs
  GET_OR_CREATE_CUSTOMER_APIURL: API_DOMAIN + webddn.DOMAIN + '/get-or-create-customer',
  UPDATE_ORDER_STATUS: API_DOMAIN + webddn.DOMAIN + '/update-order-status',
  UPDATE_MULTIPLE_ORDER_STATUSES_APIURL: API_DOMAIN + webddn.DOMAIN + '/update-multiple-order-statuses',
  GET_TEAM_MEMBERS: API_DOMAIN + webddn.DOMAIN + '/get-team-members',

  // Pending Payments Management APIs
  PENDING_PAYMENTS_APIURL: API_DOMAIN + webddn.DOMAIN + '/pending-payments',
  BULK_MARK_PAID_APIURL: API_DOMAIN + webddn.DOMAIN + '/bulk-mark-paid',
  MARK_PAYMENT_PAID_APIURL: API_DOMAIN + webddn.DOMAIN + '/mark-payment-paid',

  // NEW: Team Paid Email Management APIs
  TEAM_PAID_EMAIL_STATS_APIURL: API_DOMAIN + webddn.DOMAIN + '/team-paid-email-stats',
  VALIDATE_EMAIL_APIURL: API_DOMAIN + webddn.DOMAIN + '/validate-email',
  EXPORT_TEAM_PAID_EMAILS_APIURL: API_DOMAIN + webddn.DOMAIN + '/export-team-paid-emails',
  CHECK_EMAIL_IN_PAID_LISTS_APIURL: API_DOMAIN + webddn.DOMAIN + '/check-email-in-paid-lists',
  ALL_TEAMS_PAID_EMAIL_REPORT_APIURL: API_DOMAIN + webddn.DOMAIN + '/all-teams-paid-email-report',

    // Billing and Access Control APIs
  BILLINGS_GET_INVOICE_APIURL: API_DOMAIN + webddn.DOMAIN + '/getinvoice',
  ACLS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getacls',
  ROLES_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getroles',

 // Font Management APIs
 FONTS_GET_ALL_APIURL: API_DOMAIN + webddn.DOMAIN + '/getfont',
  
 FONTS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/fonts',
 FONT_UPLOAD_APIURL: API_DOMAIN + webddn.DOMAIN + '/fonts/upload',
 FONT_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/fonts', // + /:id
 FONT_DOWNLOAD_APIURL: API_DOMAIN + webddn.DOMAIN + '/fonts', // + /:id/download
 FONT_PREVIEW_APIURL: API_DOMAIN + webddn.DOMAIN + '/fonts', // + /:id/preview
 FONT_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/fonts', // + /:id
 FONT_DELETE_APIURL: API_DOMAIN + webddn.DOMAIN + '/fonts', // + /:id



 

  // Payment Transaction APIs
  PAYMENT_ADD_APIURL: API_DOMAIN + webddn.DOMAIN + '/addpayment',
  PAYMENTS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getpayments',
  PAYMENT_PAID_APIURL: API_DOMAIN + webddn.DOMAIN + '/paidpayment',
  PAYMENT_BALANCE_APIURL: API_DOMAIN + webddn.DOMAIN + '/paymentbalance',
  PAYMENT_TRANSACTION_ADD_APIURL: API_DOMAIN + webddn.DOMAIN + '/addtransaction',
  PAYMENTS_TRANSACTION_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/gettransaction',

  // Voice Authentication APIs
  VOICE_LOGIN_POST_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/voice-login',
  DRAFT_SIGNUP_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/draft-signup',
  PENDING_CHECKOUT_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/pending-checkout',
  VOICE_LOGIN_MULTIPLE_POST_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/voice-login-multiple',
  VOICE_CHALLENGE_POST_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/voice-challenge',
  VOICE_LOGIN_LIVENESS_POST_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/voice-login-liveness',
  REGISTER_VOICE_POST_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/register-voice',
  REGISTER_VOICE_MULTIPLE_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/register-voice-multiple',
  VOICE_ENROLL_INCOMPLETE_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/voice-enroll-incomplete',
  VOICE_COMPLETE_SIGNUP_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/voice-complete-signup',
  LINK_VOICE_TO_ACCOUNT_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/link-voice-to-account',
  VOICE_SIGNUP_DRAFT_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/voice-signup-draft',
  PASSWORD_LIST_GET_APIURL: 'https://dev.voicebiometric.xyz/api/password/?format=json',
  LOGIN_CREATE_POST_APIURL: 'https://dev.voicebiometric.xyz/api/login/',
  SEND_OTP_CREATE_POST_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/send-otp',
  VERIFY_OTP_CREATE_POST_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/verify-otp',
  AUTH_SETTINGS_APIURL: API_DOMAIN + webddn.DOMAIN + '/auth/settings',
  SIGNUP_SETTINGS_APIURL: API_DOMAIN + webddn.DOMAIN + '/signup/settings',
  HEADER_SETTINGS_APIURL: API_DOMAIN + webddn.DOMAIN + '/header/settings',
  REGISTER_CREATE_POST_APIURL: 'https://dev.voicebiometric.xyz/api/register/',

  // Cache Management APIs
  CACHE_PURGE_STATUS_APIURL: API_DOMAIN + webddn.DOMAIN + '/cache-purge-status',
  CACHE_PURGE_EVERYTHING_APIURL: API_DOMAIN + webddn.DOMAIN + '/cache-purge-everything',
  CACHE_PURGE_URLS_APIURL: API_DOMAIN + webddn.DOMAIN + '/cache-purge-urls',
  CACHE_PURGE_HOSTS_APIURL: API_DOMAIN + webddn.DOMAIN + '/cache-purge-hosts',
  CACHE_PURGE_TAGS_APIURL: API_DOMAIN + webddn.DOMAIN + '/cache-purge-tags',

  //PASSWORD_LIST_APIURL:API_DOMAIN+webddn.DOMAIN+'/auth/password_list'

  // Subscription Management APIs
  GET_SUBSCRIPTIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/subscriptions',
  GET_USER_SUBSCRIPTIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/getUserSubscriptions',
  GET_USER_SCHEDULED_SUBSCRIPTIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/getUserScheduledSubscriptions',
  GET_USER_CUSTOMER_ID_APIURL: API_DOMAIN + webddn.DOMAIN + '/getUserCustomerId',
  GET_SUBSCRIPTION_DETAILS_APIURL: API_DOMAIN + webddn.DOMAIN + '/subscription-details',
  CREATE_SUBSCRIPTION_APIURL: API_DOMAIN + webddn.DOMAIN + '/create-subscription',
  CANCEL_SUBSCRIPTION_APIURL: API_DOMAIN + webddn.DOMAIN + '/cancel-subscription',
  PAUSE_SUBSCRIPTION_APIURL: API_DOMAIN + webddn.DOMAIN + '/pause-subscription',
  RESUME_SUBSCRIPTION_APIURL: API_DOMAIN + webddn.DOMAIN + '/resume-subscription',
  REACTIVATE_SUBSCRIPTION_APIURL: API_DOMAIN + webddn.DOMAIN + '/reactivate-subscription',
  UPDATE_SUBSCRIPTION_APIURL: API_DOMAIN + webddn.DOMAIN + '/update-subscription',

  // Subscription Products & Pricing
  GET_SUBSCRIPTION_PRODUCTS_APIURL: API_DOMAIN + webddn.DOMAIN + '/subscription-products',
  GET_SUBSCRIPTION_PRICES_APIURL: API_DOMAIN + webddn.DOMAIN + '/subscription-prices',

  // Subscription Invoices & Usage
  GET_SUBSCRIPTION_INVOICES_APIURL: API_DOMAIN + webddn.DOMAIN + '/subscription-invoices',
  CUSTOMER_BILLING_INVOICES_APIURL: API_DOMAIN + webddn.DOMAIN + '/customer-billing-invoices',
  CUSTOMER_BILLING_INVOICE_APIURL: API_DOMAIN + webddn.DOMAIN + '/customer-billing-invoice',
  GET_SUBSCRIPTION_USAGE_APIURL: API_DOMAIN + webddn.DOMAIN + '/subscription-usage',
  RECORD_USAGE_APIURL: API_DOMAIN + webddn.DOMAIN + '/record-usage',

  //GET_SUBSCRIPTION_INVOICES_APIURL: API_DOMAIN + webddn.DOMAIN + '/subscription-invoices',
  GET_UPCOMING_INVOICE_APIURL: API_DOMAIN + webddn.DOMAIN + '/subscription-upcoming-invoice',
  DOWNLOAD_INVOICE_PDF_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoice-pdf',
  MARK_INVOICE_PAID_APIURL: API_DOMAIN + webddn.DOMAIN + '/mark-invoice-paid',
  VOID_INVOICE_APIURL: API_DOMAIN + webddn.DOMAIN + '/void-invoice',

  // New Invoice Management Endpoints
  INVOICE_CREATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoices',
  INVOICE_LIST_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoices/list',
  INVOICE_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoices',
  INVOICE_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoices',
  INVOICE_DELETE_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoices',
  INVOICE_SEARCH_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoices/search',
  INVOICE_PAYMENT_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoices',
  INVOICE_BULK_MARK_PAID_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoices/bulk-mark-paid',
  INVOICE_BULK_SEND_REMINDERS_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoices/bulk-send-reminders',
  INVOICE_BULK_VOID_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoices/bulk-void',
  INVOICE_EXPORT_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoices/export',
  INVOICE_PDF_DOWNLOAD_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoices',
  INVOICE_ANALYTICS_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoices/analytics',
  INVOICE_SUMMARY_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoices/summary',
  INVOICE_TOP_CUSTOMERS_APIURL: API_DOMAIN + webddn.DOMAIN + '/analytics/top-customers',
  INVOICE_GENERATE_BI_MONTHLY_APIURL: API_DOMAIN + webddn.DOMAIN + '/invoices/generate-bi-monthly',

  // Payment Methods
  GET_PAYMENT_METHOD_APIURL: API_DOMAIN + webddn.DOMAIN + '/payment-method-details',
  UPDATE_PAYMENT_METHOD_APIURL: API_DOMAIN + webddn.DOMAIN + '/update-payment-method',
  CREATE_PORTAL_SESSION_APIURL: API_DOMAIN + webddn.DOMAIN + '/create-portal-session',

  // Manual Payment Processing
  MANUAL_PAYMENT_APIURL: API_DOMAIN + webddn.DOMAIN + '/manual-payment',
  RETRY_INVOICE_PAYMENT_APIURL: API_DOMAIN + webddn.DOMAIN + '/retry-invoice-payment',
  PAY_OUTSTANDING_BALANCE_APIURL: API_DOMAIN + webddn.DOMAIN + '/pay-outstanding-balance',

  // Credit Card Management APIs
  GET_CUSTOMER_CARDS_APIURL: API_DOMAIN + webddn.DOMAIN + '/customer-cards',
  ADD_CREDIT_CARD_APIURL: API_DOMAIN + webddn.DOMAIN + '/add-credit-card',
  UPDATE_CREDIT_CARD_APIURL: API_DOMAIN + webddn.DOMAIN + '/update-credit-card',
  DELETE_CREDIT_CARD_APIURL: API_DOMAIN + webddn.DOMAIN + '/delete-credit-card',
  SET_DEFAULT_CARD_APIURL: API_DOMAIN + webddn.DOMAIN + '/set-default-card',

  // Webhook Handler
  STRIPE_WEBHOOK_APIURL: API_DOMAIN + webddn.DOMAIN + '/stripe-webhook',

  DEBUG_STRIPE_INVOICES_APIURL: API_DOMAIN + webddn.DOMAIN + '/debug-stripe-invoices',

  // Registration Management API URLs (New)
  CREATE_REGISTRATION_APIURL: API_DOMAIN  + webddn.DOMAIN + '/registrations',
  GET_REGISTRATIONS_APIURL: API_DOMAIN  + webddn.DOMAIN + '/registrations',
  GET_REGISTRATION_APIURL: API_DOMAIN  + webddn.DOMAIN + '/registrations', // ID will be appended
  EDIT_REGISTRATION_APIURL: API_DOMAIN  + webddn.DOMAIN + '/registrations', // ID will be appended
  DELETE_REGISTRATION_APIURL: API_DOMAIN  + webddn.DOMAIN + '/registrations', // ID will be appended
  GET_TEAM_REGISTRATIONS_APIURL: API_DOMAIN  + webddn.DOMAIN + '/teams', // teamId/registrations will be appended
  CHECK_REGISTRATION_STATUS_APIURL: API_DOMAIN  + webddn.DOMAIN + '/check-registration-status',
  BULK_UPDATE_TRANSPORTERS_APIURL: API_DOMAIN  + webddn.DOMAIN + '/registrations/bulk-update-transporters',
 
  DISTANCE_MATRIX_CACHE_APIURL: API_DOMAIN  +webddn.DOMAIN + '/distance-matrix-cache',
  FLAT_RATES_APIURL: API_DOMAIN  +webddn.DOMAIN + '/flat-rates',
  FLAT_RATES_FIND_ROUTE_APIURL: API_DOMAIN  +webddn.DOMAIN + '/flat-rates/find-route',

  // Pricing Templates API
  PRICING_TEMPLATES_APIURL: API_DOMAIN + webddn.DOMAIN + '/pricing-templates',

  // App Types API
  APPTYPES_APIURL: API_DOMAIN + webddn.DOMAIN + '/apptypes',

  PASSENGERS_APIURL: API_DOMAIN +webddn.DOMAIN + '/passengers',
   
  // College Methods
  GET_COLLAGE_LIST_METHOD_APIURL: API_DOMAIN + webddn.DOMAIN + '/collage/list',
  POST_COLLAGE_SAVE_METHOD_APIURL: API_DOMAIN + webddn.DOMAIN + '/collage/save',
  DELETE_COLLAGE_METHOD_APIURL: API_DOMAIN + webddn.DOMAIN + '/collage/',

  GET_GOOGLE_PHOTOS_AUTH_URL_APIURL: API_DOMAIN + webddn.DOMAIN + '/google-photos/auth-url',
  POST_GOOGLE_PHOTOS_CALLBACK_APIURL: API_DOMAIN + webddn.DOMAIN + '/google-photos/callback',
  POST_GOOGLE_PHOTOS_REFRESH_TOKEN_APIURL: API_DOMAIN + webddn.DOMAIN + '/google-photos/refresh-token',
  POST_GOOGLE_PHOTOS_ALBUMS_APIURL: API_DOMAIN + webddn.DOMAIN + '/google-photos/albums',
  POST_GOOGLE_PHOTOS_SEARCH_APIURL: API_DOMAIN + webddn.DOMAIN + '/collage/search/google-photos',

  // API Keys Management APIs (with end-to-end encryption)
  APIKEYS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/getapikeys',
  APIKEY_ADD_APIURL: API_DOMAIN + webddn.DOMAIN + '/addapikey',
  APIKEY_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/updateapikey',
  APIKEY_DELETE_APIURL: API_DOMAIN + webddn.DOMAIN + '/deleteapikey',
  APIKEY_CANCEL_APIURL: API_DOMAIN + webddn.DOMAIN + '/cancelapikey',
  APIKEY_TEST_APIURL: API_DOMAIN + webddn.DOMAIN + '/testapikey',
  APIKEY_STATS_APIURL: API_DOMAIN + webddn.DOMAIN + '/apikeyStats',
  APIKEY_ROTATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/rotateapikey',
  APIKEY_VALIDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/validateapikey',
  APIKEY_AUDIT_APIURL: API_DOMAIN + webddn.DOMAIN + '/apikeyaudit',

  // Encryption endpoints for secure API key transmission
  ENCRYPT_DATA_APIURL: API_DOMAIN + webddn.DOMAIN + '/encrypt-data',
  DECRYPT_DATA_APIURL: API_DOMAIN + webddn.DOMAIN + '/decrypt-data',

  // Production exclude list (webddn DB; used by CI and UI)
  PRODUCTION_EXCLUDE_LIST_APIURL: API_DOMAIN + webddn.DOMAIN + '/production-exclude-list',
  MAIN_S3_DEPLOY_APIURL: API_DOMAIN + webddn.DOMAIN + '/production-exclude-list/main-s3-deploy',
  CONTENT_DATABASE_NAMES_APIURL: API_DOMAIN + webddn.DOMAIN + '/content-database-names',

  // WebDDN Project Management API URLs
  WEBDDN_PROJECTS_APIURL: API_DOMAIN + webddn.DOMAIN + '/webddn-projects',
  WEBDDN_PROJECT_APIURL: API_DOMAIN + webddn.DOMAIN + '/webddn-projects', // + /:id
  WEBDDN_PROJECT_STATUS_APIURL: API_DOMAIN + webddn.DOMAIN + '/webddn-projects', // + /:id/status
  WEBDDN_PROJECT_LOGS_APIURL: API_DOMAIN + webddn.DOMAIN + '/webddn-projects', // + /:id/logs
  WEBDDN_PROJECT_REBUILD_APIURL: API_DOMAIN + webddn.DOMAIN + '/webddn-projects', // + /:id/rebuild

  // Domain Management APIs
  DOMAINS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains',
  DOMAIN_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains', // + /:id
  DOMAIN_CREATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains',
  DOMAIN_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains', // + /:id
  DOMAIN_DELETE_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains', // + /:id
  DOMAIN_CHECK_AVAILABILITY_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains/check', // + /:domain
  DOMAIN_REGISTER_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains/register',
  DOMAIN_CREATE_ZONE_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains', // + /:id/zone
  DOMAIN_DNS_RECORDS_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains', // + /:id/dns
  DOMAIN_CREATE_DNS_RECORD_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains', // + /:id/dns
  DOMAIN_UPDATE_DNS_RECORD_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains', // + /:id/dns/:recordId
  DOMAIN_DELETE_DNS_RECORD_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains', // + /:id/dns/:recordId
  DOMAIN_ENABLE_SSL_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains', // + /:id/ssl
  DOMAIN_SUPPORTED_TLDS_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains/tlds/supported',
  DOMAIN_SYNC_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains', // + /:id/sync

  // Porkbun Domain Management APIs
  PORKBUN_DOMAINS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/porkbun/domains',
  DOMAIN_CHECK_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains/check', // + /:domain
  PORKBUN_DOMAIN_REGISTER_APIURL: API_DOMAIN + webddn.DOMAIN + '/porkbun/domains/register',
  PORKBUN_DOMAIN_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/porkbun/domains', // + /:domain
  PORKBUN_DNS_RECORDS_APIURL: API_DOMAIN + webddn.DOMAIN + '/porkbun/domains', // + /:domain/dns
  PORKBUN_CREATE_DNS_RECORD_APIURL: API_DOMAIN + webddn.DOMAIN + '/porkbun/domains', // + /:domain/dns
  PORKBUN_UPDATE_DNS_RECORD_APIURL: API_DOMAIN + webddn.DOMAIN + '/porkbun/domains', // + /:domain/dns/:recordId
  PORKBUN_DELETE_DNS_RECORD_APIURL: API_DOMAIN + webddn.DOMAIN + '/porkbun/domains', // + /:domain/dns/:recordId
  PORKBUN_SUPPORTED_TLDS_APIURL: API_DOMAIN + webddn.DOMAIN + '/porkbun/tlds',
  PORKBUN_TLD_PRICING_APIURL: API_DOMAIN + webddn.DOMAIN + '/porkbun/tlds/pricing',

  // Namecheap Domain Management APIs
  NAMECHEAP_DOMAINS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/namecheap/domains',
  NAMECHEAP_DOMAIN_CHECK_APIURL: API_DOMAIN + webddn.DOMAIN + '/namecheap/domains/check', // + /:domain
  NAMECHEAP_DOMAIN_REGISTER_APIURL: API_DOMAIN + webddn.DOMAIN + '/namecheap/domains/register',
  NAMECHEAP_DOMAIN_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/namecheap/domains', // + /:domain
  NAMECHEAP_DNS_RECORDS_APIURL: API_DOMAIN + webddn.DOMAIN + '/namecheap/domains', // + /:domain/dns
  NAMECHEAP_CREATE_DNS_RECORD_APIURL: API_DOMAIN + webddn.DOMAIN + '/namecheap/domains', // + /:domain/dns
  NAMECHEAP_UPDATE_DNS_RECORD_APIURL: API_DOMAIN + webddn.DOMAIN + '/namecheap/domains', // + /:domain/dns/:recordId
  NAMECHEAP_DELETE_DNS_RECORD_APIURL: API_DOMAIN + webddn.DOMAIN + '/namecheap/domains', // + /:domain/dns/:recordId
  NAMECHEAP_DOMAIN_TRANSFER_APIURL: API_DOMAIN + webddn.DOMAIN + '/namecheap/domains/transfer',
  NAMECHEAP_DOMAIN_RENEW_APIURL: API_DOMAIN + webddn.DOMAIN + '/namecheap/domains/renew',
  NAMECHEAP_SSL_INFO_APIURL: API_DOMAIN + webddn.DOMAIN + '/namecheap/ssl/info',
  NAMECHEAP_SSL_ACTIVATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/namecheap/ssl/activate',
  NAMECHEAP_SUPPORTED_TLDS_APIURL: API_DOMAIN + webddn.DOMAIN + '/namecheap/tlds',
  NAMECHEAP_TLD_PRICING_APIURL: API_DOMAIN + webddn.DOMAIN + '/namecheap/tlds/pricing',

  // ===== PRODUCT MANAGEMENT API URLS =====

  // Product Management APIs
  PRODUCTS_APIURL: API_DOMAIN + webddn.DOMAIN + '/products',
  PRODUCT_APIURL: API_DOMAIN + webddn.DOMAIN + '/products', // + /:id
  PRODUCT_INVENTORY_APIURL: API_DOMAIN + webddn.DOMAIN + '/products', // + /:id/inventory
  PRODUCT_RESERVE_STOCK_APIURL: API_DOMAIN + webddn.DOMAIN + '/products', // + /:id/reserve-stock
  PRODUCT_RELEASE_STOCK_APIURL: API_DOMAIN + webddn.DOMAIN + '/products', // + /:id/release-stock
  PRODUCTS_LOW_STOCK_APIURL: API_DOMAIN + webddn.DOMAIN + '/products/low-stock',
  PRODUCTS_OUT_OF_STOCK_APIURL: API_DOMAIN + webddn.DOMAIN + '/products/out-of-stock',
  PRODUCT_INCREMENT_VIEWS_APIURL: API_DOMAIN + webddn.DOMAIN + '/products', // + /:id/increment-views

  // Category Management APIs
  CATEGORIES_APIURL: API_DOMAIN + webddn.DOMAIN + '/categories',
  CATEGORIES_TREE_APIURL: API_DOMAIN + webddn.DOMAIN + '/categories/tree',
  CATEGORY_APIURL: API_DOMAIN + webddn.DOMAIN + '/categories', // + /:id
  CATEGORY_PRODUCTS_APIURL: API_DOMAIN + webddn.DOMAIN + '/categories', // + /:categoryId/products
  PRODUCT_CATEGORIES_APIURL: API_DOMAIN + webddn.DOMAIN + '/products', // + /:productId/categories
  CATEGORIES_WITH_COUNT_APIURL: API_DOMAIN + webddn.DOMAIN + '/categories/with-count`', // + /:categoryId/products

  // Product Attributes & Options APIs
  PRODUCT_OPTIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/product-options',
  PRODUCT_OPTION_APIURL: API_DOMAIN + webddn.DOMAIN + '/product-options', // + /:id
  PRODUCT_OPTION_VALUES_APIURL: API_DOMAIN + webddn.DOMAIN + '/product-option-values',
  PRODUCT_OPTION_VALUES_BY_OPTION_APIURL: API_DOMAIN + webddn.DOMAIN + '/product-options', // + /:optionId/values
  PRODUCT_ATTRIBUTES_APIURL: API_DOMAIN + webddn.DOMAIN + '/product-attributes',
  PRODUCT_ATTRIBUTES_BY_PRODUCT_APIURL: API_DOMAIN + webddn.DOMAIN + '/products', // + /:productId/attributes
  PRODUCT_VARIANTS_APIURL: API_DOMAIN + webddn.DOMAIN + '/products', // + /:productId/variants
  PRODUCT_VARIANT_PRICE_APIURL: API_DOMAIN + webddn.DOMAIN + '/product-attributes/calculate-price', // + /:productId

  // Pricing APIs
  PRICING_CALCULATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/pricing/calculate', // + /:productId
  PRICING_BULK_CALCULATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/pricing/bulk-calculate',
  PRICING_CURRENCIES_APIURL: API_DOMAIN + webddn.DOMAIN + '/pricing/currencies',
  PRICING_UPDATE_RATES_APIURL: API_DOMAIN + webddn.DOMAIN + '/pricing/update-rates',
  PRICING_CONVERT_APIURL: API_DOMAIN + webddn.DOMAIN + '/pricing/convert',
  PRICING_HISTORY_APIURL: API_DOMAIN + webddn.DOMAIN + '/pricing', // + /:productId/history
  PRICING_PROMOTIONAL_APIURL: API_DOMAIN + webddn.DOMAIN + '/pricing', // + /:productId/promotional
  PRICING_SUBSCRIPTION_APIURL: API_DOMAIN + webddn.DOMAIN + '/pricing', // + /:productId/subscription
  PRICING_OPTIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/pricing/options',

  // Bulk Operations APIs
  PRODUCT_BULK_UPDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/products/bulk-update',
  PRODUCT_BULK_DELETE_APIURL: API_DOMAIN + webddn.DOMAIN + '/products/bulk-delete',
  PRODUCT_EXPORT_APIURL: API_DOMAIN + webddn.DOMAIN + '/products/export',

  // Localization APIs
  LANGUAGES_APIURL: API_DOMAIN + webddn.DOMAIN + '/languages',
  LANGUAGE_APIURL: API_DOMAIN + webddn.DOMAIN + '/languages', // + /:code
  COUNTRIES_APIURL: API_DOMAIN + webddn.DOMAIN + '/countries',
  COUNTRIES_WITH_ZONES_APIURL: API_DOMAIN + webddn.DOMAIN + '/countries/with-zones',
  COUNTRY_APIURL: API_DOMAIN + webddn.DOMAIN + '/countries', // + /:isoCode
  ZONES_APIURL: API_DOMAIN + webddn.DOMAIN + '/zones',
  ZONES_BY_COUNTRY_APIURL: API_DOMAIN + webddn.DOMAIN + '/countries', // + /:countryId/zones
  GEO_ZONES_APIURL: API_DOMAIN + webddn.DOMAIN + '/geo-zones',
  GEO_ZONE_APIURL: API_DOMAIN + webddn.DOMAIN + '/geo-zones', // + /:geoZoneId
  LOCALIZATION_DATA_APIURL: API_DOMAIN + webddn.DOMAIN + '/localization/data',
  LOCALIZATION_DETECT_LOCATION_APIURL: API_DOMAIN + webddn.DOMAIN + '/localization/detect-location',
  LOCALIZATION_FORMAT_ADDRESS_APIURL: API_DOMAIN + webddn.DOMAIN + '/localization/format-address', // + /:countryId
  LOCALIZATION_CURRENCIES_APIURL: API_DOMAIN + webddn.DOMAIN + '/localization/currencies',

  // Bulk Operations APIs
  LOCALIZATION_BULK_COUNTRIES_APIURL: API_DOMAIN + webddn.DOMAIN + '/localization/bulk/countries',
  LOCALIZATION_BULK_ZONES_APIURL: API_DOMAIN + webddn.DOMAIN + '/localization/bulk/zones',
  LOCALIZATION_BULK_CURRENCIES_APIURL: API_DOMAIN + webddn.DOMAIN + '/localization/bulk/currencies',
  LOCALIZATION_EXPORT_APIURL: API_DOMAIN + webddn.DOMAIN + '/localization/export',
  DOMAIN_CHECK_WHOIS_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains/check-whois', // + /:domain
  DOMAIN_REGISTER_PLAYWRIGHT_APIURL: API_DOMAIN + webddn.DOMAIN + '/domains/register-playwright',

  // Configuration Management API URLs
  CONFIGURATIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/configurations',
  CONFIGURATION_APIURL: API_DOMAIN + webddn.DOMAIN + '/configurations', // + /:id
  CONFIGURATION_DOMAIN_APIURL: API_DOMAIN + webddn.DOMAIN + '/configurations/domain', // + /:domain
  CONFIGURATION_VALIDATE_APIURL: API_DOMAIN + webddn.DOMAIN + '/configurations', // + /:id/validate
  CONFIGURATION_CLONE_APIURL: API_DOMAIN + webddn.DOMAIN + '/configurations', // + /:id/clone
  CONFIGURATION_EXPORT_APIURL: API_DOMAIN + webddn.DOMAIN + '/configurations', // + /:id/export
  CONFIGURATION_IMPORT_APIURL: API_DOMAIN + webddn.DOMAIN + '/configurations/import',
  CONFIGURATION_SEARCH_APIURL: API_DOMAIN + webddn.DOMAIN + '/configurations/search',
  CONFIGURATION_HISTORY_APIURL: API_DOMAIN + webddn.DOMAIN + '/configurations', // + /:id/history
  CONFIGURATION_DOMAINS_APIURL: API_DOMAIN + webddn.DOMAIN + '/configurations/domains',
  CONFIG_GENERATOR_APIURL: API_DOMAIN + webddn.DOMAIN + '/config-generator',

  // Tournament Management API URLs
  TOURNAMENTS_APIURL: API_DOMAIN + webddn.DOMAIN + '/tournaments',
  TOURNAMENT_APIURL: API_DOMAIN + webddn.DOMAIN + '/tournaments', // + /:id
  TOURNAMENT_FORMATS_APIURL: API_DOMAIN + webddn.DOMAIN + '/tournaments/formats',
  TOURNAMENT_REGISTER_APIURL: API_DOMAIN + webddn.DOMAIN + '/tournaments', // + /:id/register
  TOURNAMENT_REGISTRATIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/tournaments', // + /:id/registrations
  TOURNAMENT_PLAYERS_APIURL: API_DOMAIN + webddn.DOMAIN + '/tournaments', // + /:id/teams/:teamId/players
  TOURNAMENT_COACHES_APIURL: API_DOMAIN + webddn.DOMAIN + '/tournaments', // + /:id/teams/:teamId/coaches
  TOURNAMENT_GAMES_APIURL: API_DOMAIN + webddn.DOMAIN + '/tournaments', // + /:id/games
  TOURNAMENT_GAME_APIURL: API_DOMAIN + webddn.DOMAIN + '/tournaments', // + /:id/games/:gameId
  TOURNAMENT_LIVE_STATS_APIURL: API_DOMAIN + webddn.DOMAIN + '/tournaments', // + /:id/games/:gameId/live
  TOURNAMENT_UPDATE_STATS_APIURL: API_DOMAIN + webddn.DOMAIN + '/tournaments', // + /:id/games/:gameId/stats
  TOURNAMENT_UPDATE_SCORE_APIURL: API_DOMAIN + webddn.DOMAIN + '/tournaments', // + /:id/games/:gameId/score


  GENERATE_META_DESCRIPTION: API_DOMAIN + webddn.DOMAIN +'/ai/generate-meta-description',

  // Image Processing API URLs
  IMAGE_PROCESSING_REMOVE_BACKGROUND_APIURL: API_DOMAIN + webddn.DOMAIN + '/image-processing/remove-background',
  IMAGE_PROCESSING_PROFILE_REQUEST_UPLOAD_APIURL: API_DOMAIN + webddn.DOMAIN + '/image-processing/profile-image/request-upload',
  IMAGE_PROCESSING_PROFILE_DIRECT_UPLOAD_APIURL: API_DOMAIN + webddn.DOMAIN + '/image-processing/profile-image/direct-upload',
  IMAGE_PROCESSING_PROFILE_READ_URL_APIURL: API_DOMAIN + webddn.DOMAIN + '/image-processing/profile-image/read-url',

  // Settings
  SETTINGS_GET_APIURL: API_DOMAIN + webddn.DOMAIN + '/settings',

  // Inquiry Management API URLs
  GET_INQUIRIES_APIURL: API_DOMAIN + webddn.DOMAIN + '/inquiries',

  // SMS Gateway
  SMS_GATEWAY_APIURL: API_DOMAIN + webddn.DOMAIN + '/sms-gateway',

  // Health & Fitness APIs
  HEALTH_FITNESS_SESSIONS_APIURL: API_DOMAIN + webddn.DOMAIN + '/health-fitness/sessions',
  HEALTH_FITNESS_ROUTINES_APIURL: API_DOMAIN + webddn.DOMAIN + '/health-fitness/routines',
  HEALTH_FITNESS_NUTRITION_APIURL: API_DOMAIN + webddn.DOMAIN + '/health-fitness/nutrition',
  HEALTH_FITNESS_SLEEP_APIURL: API_DOMAIN + webddn.DOMAIN + '/health-fitness/sleep',
  HEALTH_FITNESS_HYDRATION_APIURL: API_DOMAIN + webddn.DOMAIN + '/health-fitness/hydration',
  HEALTH_FITNESS_PROGRESS_APIURL: API_DOMAIN + webddn.DOMAIN + '/health-fitness/progress',
  HEALTH_FITNESS_CONFIG_APIURL: API_DOMAIN + webddn.DOMAIN + '/health-fitness/config',

};